/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import style from './mapping.module.scss';
import { getResourceList, selectResourceByName } from 'store/page/pageSlice';
import {
  ADAPTIVE_SIMILAR_IMAGES_LIMIT,
  DESKTOP_SIMILAR_IMAGES_LIMIT,
  MIN_SCREEN_WIDTH,
  tagsToString,
} from 'utils/utils';
import cx from 'classnames';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import GeneralSearch from 'controls/search/generalSearch/generalSearch';
import isUndefined from 'lodash-es/isUndefined';
import { useSearchParams } from 'react-router-dom';
import GridSection from 'components/gridSection/gridSection';
import { selectIsAuth } from 'store/auth/authSlice';
import SearchResult from 'components/searchResult/searchResult';
import { selectStartTags } from 'store/tagsSlice';
import { useViewport } from 'contexts/viewportContext';

export default function Mapping() {
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(selectIsAuth);
  const startTags = useAppSelector(selectStartTags);
  const tagsString = `&tags=${tagsToString(startTags)}`;
  const { width } = useViewport();

  const [searchParams] = useSearchParams();
  const searchTags = searchParams.get('tags');

  const photosSelector = selectResourceByName.bind(null, 'photos');
  const vectorsSelector = selectResourceByName.bind(null, 'vectors');
  const illustrationsSelector = selectResourceByName.bind(
    null,
    'illustrations'
  );

  const photosResource = useAppSelector(photosSelector);
  const vectorsResource = useAppSelector(vectorsSelector);
  const illustrationsResource = useAppSelector(illustrationsSelector);

  const isPhotos = isUndefined(photosResource) || photosResource?.total;
  const isVectors = isUndefined(vectorsResource) || vectorsResource?.total;
  const isIllustrations =
    isUndefined(illustrationsResource) || illustrationsResource?.total;

  const isAdaptiveModeOn = width <= MIN_SCREEN_WIDTH;
  const similarImagesLimit = isAdaptiveModeOn
    ? ADAPTIVE_SIMILAR_IMAGES_LIMIT
    : DESKTOP_SIMILAR_IMAGES_LIMIT;

  useEffect(() => {
    if (isAuth) {
      dispatch(
        getResourceList({
          _saveName: 'photos',
          special: null,
          tags: searchParams.get('tags') || null,
          category: 'Фотографии',
          offset: 0,
          limit: similarImagesLimit,
          sort: 'default',
        })
      );
      dispatch(
        getResourceList({
          _saveName: 'vectors',
          special: null,
          tags: searchParams.get('tags') || null,
          category: 'Векторная графика',
          offset: 0,
          limit: similarImagesLimit,
          sort: 'default',
        })
      );
      dispatch(
        getResourceList({
          _saveName: 'illustrations',
          special: null,
          tags: searchParams.get('tags') || null,
          category: 'Иллюстрации',
          offset: 0,
          limit: similarImagesLimit,
          sort: 'default',
        })
      );
    }
  }, [isAuth, searchTags]);

  const isResources = isPhotos || isVectors || isIllustrations ? true : false;

  return (
    <>
      <div className={style.container}>
        <div className={cx(style.searchWrapper, 'adaptive-search__container')}>
          <GeneralSearch
            className={style.shadow}
            baseURL={'/mapping'}
          ></GeneralSearch>
        </div>
        <SearchResult isResources={isResources}></SearchResult>

        {isPhotos || isVectors || isIllustrations ? (
          <>
            {isPhotos ? (
              <GridSection
                text="Фотографии"
                href={`/search?category=Фотографии${tagsString}`}
                resourceName="photos"
              ></GridSection>
            ) : (
              ''
            )}
            {isVectors ? (
              <GridSection
                text="Векторная графика"
                href={`/search?category=Векторная графика${tagsString}`}
                resourceName="vectors"
              ></GridSection>
            ) : (
              ''
            )}
            {isIllustrations ? (
              <GridSection
                text="Иллюстрации"
                href={`/search?category=Иллюстрации${tagsString}`}
                resourceName="illustrations"
              ></GridSection>
            ) : (
              ''
            )}
          </>
        ) : (
          <span className={'notFoundBlock'}></span>
        )}
      </div>
    </>
  );
}
